import { ApiError } from "../../../shared/api-client";

/** The one error normaliser: prefers the server's ApiError message. */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  return err instanceof Error ? err.message : String(err);
}
